import axios from "axios";

import LocationPricing from "./components/LocationPricing/LocationPricing.svelte";
import Promotions from "./components/Promotions/Promotions.svelte";
import AmenitiesOptions from "./components/LocationAmenities/LocationAmenities.svelte";
import HolidayParty from "./components/Book/HolidayParty/HolidayParty-v2.svelte";
import GlowRoom from "./components/GlowRoom/GlowRoom.svelte";

import { location, type, step } from "./stores/BookingStore";

import { GetMoneySign, addScript } from "./helpers";

declare global {
  interface Window {
    jQuery: any;
    bat_location_vars: any;
  }
}

const $ = window.jQuery;

let locationInfo: any;

$(function() {
  if (typeof window.bat_location_vars !== "undefined") {
    // Search the location info to the the information
    axios
      .get(`/wp-json/badaxe/v1/location/${window.bat_location_vars.PID}`)
      .then((result) => {
        let data = result.data;
        location.update((l) => {
          let u = { ...l };
          u.id = window.bat_location_vars.PID;
          u.name = data.location[0];
          u.country = data.general.country[0];
          u.address = data.general.address[0];
          u.phone = data.general.phone[0];
          u.timeslots = data.timeslots;
          u.region = data.schema.region[0];
          u.moneySign = GetMoneySign(data.general.country[0] as string);
          u.rates = {
            normal: data.rates.normal,
            corporate: data.rates.corporate,
            walkin: data.rates.walkin,
            hero: data.rates.hero,
          };
          u.occasions = data.occasions;
          return u;
        });
        location.subscribe((value) => {
          locationInfo = value;
        });

        if (document.getElementById("location-pricing")) {
          new LocationPricing({
            target: document.getElementById("location-pricing"),
            props: {
              locationInformation: locationInfo,
            },
          });
        }
      });
  }

  // Promotions
  if (document.getElementById("location-promotions")) {
    new Promotions({
      target: document.getElementById("location-promotions"),
      props: {},
    });
  }

  // Amenities options
  if (document.getElementById("location-amenities-options")) {
    new AmenitiesOptions({
      target: document.getElementById("location-amenities-options"),
      props: {},
    });
  }

  // if (document.getElementById("holiday-party")) {
  //   new HolidayParty({
  //     target: document.getElementById("holiday-party"),
  //     props: {},
  //   });
  // }

  if (document.getElementById("glow-room")) {
    new GlowRoom({
      target: document.getElementById("glow-room"),
      props: {}
    });
  }

  // Load booking engine
  addScript(
    "body",
    `${window.wpdata.baseUrl}/wp-content/themes/badaxe/dist/js/v3/bookengine.bundle.js?v=${window.bat_location_vars.bat_version}`,
    "bookingengine-bundle",
    null,
    false
  );

  // addScript(
  //   "body",
  //   `${window.wpdata.baseUrl}/wp-content/themes/badaxe/dist/js/v3/components.bundle.js?v=${window.bat_location_vars.walkins_version}`,
  //   "bat-location-main-js",
  //   null,
  //   false
  // );
}); // end document load
